import { FC } from 'react';
import { DigitalFormScopeHooks } from '@frontend/digital-forms-scope';
import { FormsExperienceView } from '../../../../../../shared/components';
import { useTemplatePreviewStore, useTemplatePreviewContext } from '../provider';
import MobilePreview from './mobile-preview/mobile-preview.component';
import { previewContainerStyle, containerStyle, formsExperienceViewContainerStyle } from './preview-body.style';

const TemplatePreviewBody: FC = () => {
  const { formsEnabledGLSLocationIds } = DigitalFormScopeHooks.useFormsEnabledOrgLocations();
  const { previewMode } = useTemplatePreviewStore(['previewMode']);
  const { template } = useTemplatePreviewContext();
  const locationId = formsEnabledGLSLocationIds.length > 0 ? formsEnabledGLSLocationIds[0] : '';
  const templateId = template.id || '';

  return (
    <section css={containerStyle}>
      <div css={previewContainerStyle}>
        {previewMode === 'desktop' ? (
          <div css={formsExperienceViewContainerStyle}>
            <FormsExperienceView key={template.id} token={templateId} type='template' locationId={locationId} />
          </div>
        ) : (
          <MobilePreview templateId={templateId} locationId={locationId} />
        )}
      </div>
    </section>
  );
};

export default TemplatePreviewBody;
